import ReportsListScreen from '../../components/reports/reports-list';

function ReportsList() {
  return <ReportsListScreen />;
}

export default ReportsList;
